import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "../../utils/Button";
import LayOverModal from "../../utils/LayOverModal";
import question from "../../utils/question.png";
import AutocompleteDropdown from "../../utils/AutoCompleteDropdown";
import { ONBOARDING_STATUS } from "../../utils/constants";

const OnboardingStep3 = (props) => {
  const {
    step,
    verificationLoader,
    handleRowUpdate,
    countryOptions,
    formDataStep3,
    setFormDataStep3,
  } = props;

  const headerStyle = {
    fontSize: "20px",
    fontWeight: "600",
    color: "#3C3C3C",
    margin: "2rem 0rem 1rem 0rem",
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    color: "#808080",
    backgroundColor: "#F6F6F6",
  };

  // Validate form whenever data changes
  const isFormIncomplete = () => {
    return Object.values(formDataStep3).some((value) => value.length === 0);
  };

  const handleInputChange = (field, value) => {
    setFormDataStep3((prev) => ({ ...prev, [field]: value }));
  };

  const handleUpdate = () => {
    handleRowUpdate({
      updateData: {
        noFlightsTaken: formDataStep3?.flights,
        nearestAirport: formDataStep3?.airport,
        countryOfResidence: formDataStep3?.country,
        passportNo: formDataStep3?.passportNumber,
        onboardingStatus: {
          status: ONBOARDING_STATUS.IN_ONBOARDING_4,
        },
      },
    });
  };

  const noOfFlightOptions = [
    "Less than 2",
    "3-6",
    "7-10",
    "11-14",
    "15 or more",
  ];
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div style={{ width: "100%", color: "#3C3C3C" }}>
      <div style={headerStyle}>Travel Details</div>

      <form style={{ fontSize: "14px" }}>
        <label style={{ display: "block", marginBottom: "10px" }}>
          Country of Residence
        </label>
        {/* <select
          value={formDataStep3.country}
          onChange={(e) => handleInputChange("country", e.target.value)}
          style={inputStyle}
        >
          {countryOptions?.map((country) => (
            <option key={country.name} value={country.name}>
              {country?.name}
            </option>
          ))}
        </select> */}
        <AutocompleteDropdown
          options={countryOptions?.map((nation) => ({
            label: nation.name,
            value: nation.name,
          }))}
          placeholder={formDataStep3.country}
          selectedOption={formDataStep3.country}
          onSelect={(value) => handleInputChange("country", value)}
          optionWindowHeight="7rem"
          name="nationality"
        />

        {/* Nearest Airport */}
        <label style={{ display: "block", marginBottom: "10px" }}>
          Nearest Airport
        </label>
        <input
          type="text"
          placeholder="Enter nearest airport"
          maxLength="250"
          value={formDataStep3.airport}
          onChange={(e) => handleInputChange("airport", e.target.value)}
          style={inputStyle}
        />

        {/* International Flights */}
        <label style={{ display: "block", marginBottom: "10px" }}>
          How many international flights did you perform in the last 12 months?
        </label>
        <div style={{ display: "flex", gap: "0.1rem", flexWrap: "wrap" }}>
          {noOfFlightOptions.map((option) => (
            <button
              key={option}
              type="button"
              style={{
                margin: "5px",
                border:
                  formDataStep3.flights === option
                    ? "2px solid #1742F54D"
                    : "1px solid #ccc",
                borderRadius: "10px",
                padding: "0.5rem 1.3rem",
              }}
              onClick={() => handleInputChange("flights", option)}
            >
              {option}
            </button>
          ))}
        </div>

        {/* Passport Number */}
        <label style={{ display: "block", margin: "15px 0px 5px 0px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>Passport Number </span>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                color: "#1742F5",
                cursor: "pointer",
              }}
              onClick={() => setIsModalOpen(true)}
            >
              <span>
                {" "}
                <img
                  style={{ width: "1rem", height: "auto" }}
                  src={question}
                  alt="question"
                />{" "}
              </span>
              Why do we need this?
            </span>
          </div>
        </label>
        <input
          type="text"
          placeholder="Enter your passport number"
          maxLength="250"
          value={formDataStep3.passportNumber}
          onChange={(e) => handleInputChange("passportNumber", e.target.value)}
          style={inputStyle}
        />
      </form>

      <br />
      <Button
        text={"Continue"}
        size={"md"}
        onClick={() => handleUpdate(step)}
        loading={verificationLoader}
        disabled={isFormIncomplete()}
      />
      <LayOverModal
        isOpen={isModalOpen}
        heading={"About Passport Number"}
        content={
          <p className="text-left space-y-1.5 text-[14px] text-[#656465]">
            <p>
              Your passport number will be used as your login credential for
              security purposes. Please ensure:{" "}
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>You have your passport readily available</li>
              <li>Double-check the number for accuracy</li>
              <li>Keep this information secure</li>
            </ul>
          </p>
        }
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

OnboardingStep3.propTypes = {
  step: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
};

export default OnboardingStep3;
